// extracted by mini-css-extract-plugin
export default {"ExpandAndCenter":"EmbeddedVirtualVenuePage_ExpandAndCenter__Q+oX0"};